
/* Theme customizations by Second Society */

$(document).ready(function(){
  let slidesToShow = 1;
  if (screen.width > 990) {
    slidesToShow = 3;
  }
  console.log('slider' + screen.width + ", " + slidesToShow);
  
  $('.product-slider').each(function(){
    $(this).slick({
      slidesToShow: 3,        // Number of fully visible slides
      slidesToScroll: 1,      // Number of slides to scroll at a time
      infinite: true,         // Infinite loop
      variableWidth: false,    // Allows for variable slide widths
      centerMode: true,       // Center the active slide
      focusOnSelect: true,
      autoplay: true, // make it auto later ~~
      autoplaySpeed: 3500,
      speed: 500,
      centerPadding: '150px',
      
      useTransform: true,
      mode: 'vertical',
      responsive: [
        {
          breakpoint: 990,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '0px',
            slidesToShow: 1,
            dots: true,
          }
        }
      ]
    });
  });
  
})
// document.addEventListener('DOMContentLoaded', function() {
//   setTimeout(ert, 1000);
//   // console.log(document.getElementsByClassName('product-slider'));
//   // console.log(document.getElementById('Slider-template--20900137042228__5d8d9ff1-6797-4b10-b1e7-c5197eb296e1'));
//   // document.getElementsByClassName('product-slider').forEach((slider) => {
//   //   console.log(slider);
//   // })
// });

// function ert(){
//   console.log(document.getElementsByClassName('product-slider'));
//   var slider = document.getElementsByClassName('product-slider')[0];
//   slider.slick();
//   // document.getElementsByClassName('product-slider').forEach((slider) => {
//   //   console.log(slider);
//   // })
// }